module.exports = __webpack_public_path__ + "static/media/IMG_0284.f2f1cf55.jpg";